import request from '@/utils/request'

// 登录方法
export function login(account, password) {
    return request({
        url: '/login',
        method: 'post',
        data: {
            account,
            password
        }
    })
}

// 注册方法
export function register(username, password, email) {
    return request({
        url: '/register',
        method: 'post',
        data: {
            username,
            password,
            email,
        }
    })
}

// 获取用户信息
export function getInfo() {
    return request({
        url: '/getInfo',
        method: 'get',
    })
}

// 登出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  })
}

// 生成微信二维码
export function generateQRCode() {
  return request({
    url: '/wechat/qrcode/generate',
    method: 'post',
  })
}

// 查询二维码登录状态
export function checkQRCodeStatus(sceneValue) {
  return request({
    url: '/wechat/qrcode/status',
    method: 'get',
    params: {
      scene: sceneValue
    }
  })
}